if(typeof _.zipObject === 'undefined') { var e = new Error("Cannot find module '_.zipObject'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.zipObject;